"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _filterChildren = _interopRequireDefault(require("../../../utils/Children/filterChildren"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TableHeader = function TableHeader(props) {
  var className = props.className,
      id = props.id,
      style = props.style,
      secondaryDataList = props.secondaryDataList,
      children = props.children;

  var tableHeaderClass = function tableHeaderClass() {
    return (0, _classnames["default"])({
      'ui-table-header': true
    }, className);
  };

  var newChildren = (0, _filterChildren["default"])(children, {
    secondaryDataList: secondaryDataList
  });
  return /*#__PURE__*/_react["default"].createElement("thead", {
    id: id,
    className: tableHeaderClass(),
    style: style
  }, newChildren);
};

TableHeader.propTypes = {
  /** id for reference */
  id: _propTypes["default"].string,

  /** className for reference */
  className: _propTypes["default"].string,

  /** Override the inline-styles of the root element || Not Recommended */
  style: _propTypes["default"].object,

  /**
   * children props for content inside
   * @ignore
   */
  children: _propTypes["default"].node,

  /**
   * Data (in columns) to hide passed from TableRow component
   * @ignore
   */
  secondaryDataList: _propTypes["default"].array
};
TableHeader.defaultProps = {
  id: '',
  className: '',
  children: [],
  style: {},
  secondaryDataList: []
};
var _default = TableHeader;
exports["default"] = _default;